<template>
  <div class="postion-relative w-100">
    <template>
      <div
        class="sticky-search-bar"
        :class="{ 'pb-0': !isBrand, 'retailer-view-tag': !!directRetailerId }"
      >
        <!-- ECommerce Header -->
        <section id="ecommerce-header">
          <div class="row">
            <div class="col-sm-12">
              <div class="ecommerce-header-items">
                <div class="result-toggler">
                  <div class="search-results d-block d-lg-none">
                    {{ totalProducts || 0 }} product{{
                      totalProducts > 1 ? 's' : ''
                    }}
                    found
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          class="ecommerce-searchbar"
          :class="{
            'guest-user': isGuest,
            'brand-user': isBrand,
            'retailer-user': isRetailer,
          }"
        >
          <div class="search-section d-flex">
            <div class="search-and-filter">
              <div
                ref="searchInputBox"
                class="search-input position-relative h-100"
              >
                <b-input-group class="input-group-merge h-100">
                  <b-form-input
                    v-model="filters.search"
                    v-b-tooltip.hover.bottom="
                      showSearchBarToolTip ? searchBarPlaceholderText : ''
                    "
                    :placeholder="searchBarPlaceholderText"
                    class="search-product h-100 pr-3"
                    @input="searchProducts"
                    @focus="
                      isFocusedSearchBar = true;
                      showSearchBarToolTip = false;
                    "
                    @blur="isFocusedSearchBar = false"
                    @mouseenter="setShowTooltip()"
                  />
                </b-input-group>
                <feather-icon
                  icon="SearchIcon"
                  size="18"
                  class="search-icon shop bg-white"
                />
              </div>
              <div class="filter-and-delivery-date h-100">
                <b-button
                  variant="outline-primary"
                  class="filter-button-1 border-2 filter-button mr-1"
                  @click="mqShallShowLeftSidebar = true"
                >
                  <b-img
                    :src="filterIcon"
                    alt="Error Icon"
                  />
                  Filter
                </b-button>
                <div class="filter-delivery-date">
                  <div
                    v-if="!isGuest"
                    class="position-relative h-100"
                  >
                    <b-button
                      :variant="showDateFilter ? 'primary' : 'outline-primary'"
                      class="filter-date-btn font-weight-bolder px-50 h-100"
                      @click="showDateFilter = !showDateFilter"
                    >
                      <feather-icon icon="FilterIcon" />
                      <span class="filter-by-text mr-50"> Filter By </span>
                      <span> Delivery Date </span>
                      <div
                        v-if="selectedAvailabilityDate.length"
                        class="red-dot"
                      />
                      <feather-icon
                        :icon="
                          showDateFilter ? 'ChevronUpIcon' : 'ChevronDownIcon'
                        "
                        class="postion-absolute position-right-0"
                      />
                    </b-button>
                    <div
                      v-if="showDateFilter"
                      class="custom-popover"
                    >
                      <div class="pb-1">
                        <span
                          class="color-neutral-black font-weight-bolder"
                        >Filter By Delivery Date</span>
                      </div>
                      <div>
                        <div class="mb-10-px">
                          Delivery Window
                        </div>
                        <b-button
                          class="delivery-btn"
                          variant="outline-secondary"
                          @click="
                            showFilterDateOptions = !showFilterDateOptions
                          "
                        >
                          Select Delivery Window Dates
                          <feather-icon
                            :icon="
                              showFilterDateOptions
                                ? 'ChevronUpIcon'
                                : 'ChevronDownIcon'
                            "
                            class="postion-absolute position-right-0 ml-1"
                          />
                        </b-button>
                        <b-list-group
                          v-if="showFilterDateOptions"
                          class="date-list scroll-bar"
                        >
                          <template v-if="filterByAvailabilityDates.length">
                            <b-list-group-item
                              v-for="(date, index) of filterByAvailabilityDates"
                              :key="date"
                              class="d-flex align-items-center"
                              @click="setDateFiler(index)"
                            >
                              <b-form-checkbox
                                v-model="selectedAvailabilityDate"
                                class="shipment-checkbox date-checkbox"
                                :value="index"
                                stacked
                                @change="setDateFiler(index)"
                              />
                              <span class="ml-5-px">{{ date }}</span>
                            </b-list-group-item>
                          </template>
                          <template v-else>
                            <b-list-group-item
                              class="d-flex align-items-center"
                            >
                              No Dates Available
                            </b-list-group-item>
                          </template>
                        </b-list-group>
                        <template
                          v-if="
                            selectedAvailabilityDate.length &&
                              !showFilterDateOptions
                          "
                        >
                          <div class="mt-10-px">
                            {{ selectedAvailabilityDate.length }} Delivery
                            {{
                              selectedAvailabilityDate.length > 1
                                ? 'Windows'
                                : 'Window'
                            }}
                            Selected:
                          </div>
                          <div class="preview-dates scroll-bar">
                            <div
                              v-for="date of selectedAvailabilityDate"
                              :key="date"
                              class="delivery-date-window"
                            >
                              {{ filterByAvailabilityDates[date] }}
                              <feather-icon
                                icon="XIcon"
                                size="16"
                                class="drop-icon"
                                @click="removeDateFilter(date)"
                              />
                            </div>
                          </div>
                        </template>
                      </div>
                      <b-button
                        variant="info"
                        class="w-100 font-weight-bolder mt-10-px"
                        :disabled="!selectedAvailabilityDate.length"
                        @click="filterByDate"
                      >
                        Apply Filters
                      </b-button>
                    </div>
                  </div>
                </div>
                <b-modal
                  id="connection_request"
                  ref="connectionRequest"
                  class="custom-modal"
                  size="lg"
                  hide-footer
                  hide-header
                  hide-header-close
                  no-close-on-backdrop
                  centered
                >
                  <connection-request
                    :brand-id="brandId"
                    :retailer-id="retailerId"
                    @close-modal="closeModal"
                    @request="requestForConnection"
                  />
                </b-modal>
              </div>

              <!-- Select all button -->
              <div class="ml-md-1 mt-1 mt-md-0">
                <select-all-button
                  :is-selected-all="isSelectedAllOnScreen"
                  @toggle-select-all="onToggleSelectAll"
                />
              </div>

              <div
                v-if="
                  collectionData &&
                    collectionData.availableCurrencies &&
                    collectionData.availableCurrencies.length > 0
                "
                class="ml-md-1 mt-1 mt-md-0"
              >
                <currency-dropdown
                  :base-currency="collectionBaseCurrency"
                  :selected-currency="filters.currency"
                  :currencies="collectionData.availableCurrencies || []"
                  @on-selected-currency="filterByCurrency"
                />
              </div>
            </div>
            <div class="search-and-sort">
              <div class="search-input-1 position-relative">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model="filters.search"
                    v-b-tooltip.hover.bottom="
                      showSearchBarToolTip ? searchBarPlaceholderText : ''
                    "
                    :placeholder="searchBarPlaceholderText"
                    class="search-product h-100 pr-3"
                    @input="searchProducts"
                    @focus="
                      isFocusedSearchBar = true;
                      showSearchBarToolTip = false;
                    "
                    @blur="isFocusedSearchBar = false"
                    @mouseenter="setShowTooltip()"
                  />
                </b-input-group>
                <feather-icon
                  icon="SearchIcon"
                  size="18"
                  class="search-icon shop bg-white"
                />
              </div>
              <div>
                <b-button
                  variant="outline-primary"
                  class="
                    filter-button-2
                    border-2
                    float-left
                    filter-button
                    px-1
                    mr-1
                    h-100
                  "
                  @click="mqShallShowLeftSidebar = true"
                >
                  <b-img
                    :src="filterIcon"
                    alt="Error Icon"
                  />
                  Filter
                </b-button>
                <b-button
                  class="custom-icon-btn h-100"
                  :variant="
                    itemViewClass === PRODUCTS_VIEW.GRID_VIEW
                      ? 'outline-info'
                      : 'outline-secondary'
                  "
                  @click="onCompactToggleClick"
                >
                  <LargeGridViewIcon />
                </b-button>
                <b-button
                  class="custom-icon-btn h-100"
                  :variant="
                    itemViewClass === PRODUCTS_VIEW.COMPACT_GRID_VIEW
                      ? 'outline-info'
                      : 'outline-secondary'
                  "
                  @click="onCompactToggleClick"
                >
                  <CompactGridViewIcon />
                </b-button>
                <b-dropdown
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :text="sortBy.text"
                  right
                  variant="outline-primary"
                  class="custom-dropdown-radius h-100"
                >
                  <b-dropdown-item
                    v-for="sortOption in sortByOptions"
                    :key="sortOption.value"
                    @click="sortBy = sortOption"
                  >
                    {{ sortOption.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div
            v-if="!isBrand"
            class="d-flex col-12 pl-2-px align-items-center group-by pr-0"
          >
            <div>
              <span
                class="color-grey-sult font-size-16-px"
              >Group Products by:
              </span>
              <b-dropdown
                variant="none"
                class="group-dropdown"
                no-caret
              >
                <template #button-content>
                  <span class="pr-2-px font-size-16-px">
                    {{ selectedGroup || defaultGroup }}</span>
                  <feather-icon
                    class="align-middle"
                    icon="ChevronDownIcon"
                    size="16"
                  />
                </template>
                <div class="heading">
                  Group By
                </div>
                <b-dropdown-item
                  v-for="group in groups"
                  :key="group"
                  :active="selectedGroup === group"
                  @click="groupProducts(group)"
                >
                  {{ group }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div
              v-if="selectedWishlist"
              class="ml-1 ml-auto"
            >
              <b-button
                id="select_wishlist_button"
                variant="outline-primary"
                @click="onClickSelectWishlist"
              >
                <div
                  class="d-flex"
                  :class="{
                    'has-value': !!(selectedWishlist && selectedWishlist.name),
                  }"
                >
                  <feather-icon
                    icon="HeartIcon"
                    size="16"
                    class="text-danger"
                  />
                  <span class="ml-1">
                    {{ wishlistBtnLabel }}
                  </span>
                </div>
              </b-button>
              <b-tooltip
                target="select_wishlist_button"
                variant="primary"
                placement="bottomleft"
              >
                {{ selectedWishlist.name }}
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
      <!-- Overlay -->
      <div
        v-show="totalProducts > 0"
        class="mt-1"
      >
        <shop-products
          ref="shopProductsRef"
          :indexes.sync="indexes"
          :products="products"
          :wishlists="wishlists"
          :selected-wishlist="selectedWishlist"
          :is-show-wsp="isShowWsp"
          :direct-retailer-id="directRetailerId"
          :is-brand-not-accessible="isBrandNotAccessible"
          :connection-request-status="connectionRequestStatus"
          :inactive-collection="inactiveCollection"
          :collection-id="collectionId"
          :has-direct-retailers="hasDirectRetailers"
          :react-handle-cart-action-click="reactHandleCartActionClick"
          :item-view-class="itemViewClass"
          :react-toggle-product-in-wishlist="reactToggleProductInWishlist"
          :add-multiple-items-cart-action-click="
            addMultipleItemsCartActionClick
          "
          :should-change-wishlist.sync="shouldChangeWishlist"
          :is-check-box-disabled="false"
          :is-disable-create-wishlist="isDisableCreateWishlist"
          :collection-products-count="collectionData.count"
          @update-products-by-wishlist="updateProductsByWishlistId"
          @on-deselect-products="deselectedProducts = $event"
          @on-select-all-move-to-wishlist="onSelectAllMoveToWishlist($event)"
          @force-toggle-select="forceToggleSelect"
        />
        <tool-kit
          v-if="products.length"
          :toolkit-page="TOOLKIT_PAGE.SHOP_PRODUCTS"
        />
        <!-- Infinite Scroll Loading -->
        <section
          v-if="shouldShowInfiniteLoader"
          class="mt-4"
        >
          <b-row>
            <b-col
              cols="12"
              class="text-center"
            >
              <b-spinner
                ref="loadingIcon"
                class="loading-icon"
                label="Loading..."
              />
            </b-col>
          </b-row>
        </section>
      </div>
      <div
        v-show="shouldShowEmptyWishlistMsg"
        class="empty-wishlist-msg"
      >
        <div
          id="no-product-wishlist-err"
          class="text-center font-weight-bold h2"
        >
          No products found in this
          {{ selectedWishlist ? 'wishlist' : 'collection' }}.
        </div>
      </div>
      <div v-show="totalProducts === 0">
        <empty-products-message v-if="filters.search" />
      </div>

      <!-- Sidebar -->
      <portal
        v-if="filterSetup"
        to="content-renderer-sidebar-detached-left"
      >
        <shop-filter
          :filters="filters"
          :filter-options="filterOptions"
          :whole-sale-enable="!isGuest && isShowWsp"
          :total-products="totalProducts"
          :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
          @update-filters="fetchShopProducts"
          @close-sidebar="closeSideBar"
        />
      </portal>
    </template>
    <add-products-selection-hint-modal />
    <b-modal
      id="download_catalog"
      centered
      :title="isBrandCatalogueEnabled ? 'Download Collection' : 'Download Catalogue'"
      hide-footer
    >
      <!-- KP-3919 kill switch. OFF is the pre-KP-3919 body verbatim —
           including `DOWNLOAD_OPTIONS.CATALOG.XLSX.XLSX`, which evaluates to
           undefined. That is how it shipped, and the radio is `checked` so the
           value is never read. Left alone deliberately: this branch's value is
           being unchanged. -->
      <div
        v-if="!isBrandCatalogueEnabled"
        class="mb-2 order-download-modal"
      >
        <div class="mt-1">
          <div class="input-container w-100">
            <label
              :key="DOWNLOAD_OPTIONS.CATALOG.XLSX"
              class="selected-color w-100"
            >
              <input
                type="radio"
                name="exportType"
                :value="DOWNLOAD_OPTIONS.CATALOG.XLSX.XLSX"
                checked
              >
              <span class="text-nowrap mb-1">
                <b-card-text class="ml-1"> Download Excel </b-card-text>
              </span>
            </label>
            <b-button
              class="float-right my-1 w-100"
              variant="primary"
              :disabled="downloading"
              @click="downloadCollection()"
            >
              {{ downloading ? 'Downloading...' : 'Download Collection' }}
            </b-button>
          </div>
        </div>
      </div>
      <!-- Shared picker — offer whatever this collection actually has,
           individually or as one structured ZIP. -->
      <collection-download-picker
        v-else
        :collection="collectionData"
        :collection-id="collectionId"
        :retailer-id="directRetailerId"
        :downloading="downloading"
        @download="downloadCollection"
        @close-popup="$bvModal.hide('download_catalog')"
      />
    </b-modal>
  </div>
</template>

<script>
import CompactGridViewIcon from '@/@core/assets/svg-components/CompactGridViewIcon.vue'
import LargeGridViewIcon from '@/@core/assets/svg-components/LargeGridViewIcon.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import analytics, { getCollectionMixpanelObj } from '@/@core/utils/analytics'
import { setFilter, DOWNLOAD_DELIVERABLE } from '@/common-utils'
import CollectionDownloadPicker from '@/components/collection/CollectionDownloadPicker.vue'
import {
  isBrandCatalogueEnabled as brandCatalogueFlagOn,
  useBrandCatalogueFlag,
} from '@/composables/useBrandCatalogueFlag'
import { buildColorEntries } from '@/utils/colorEntries'
import constants, {
  DOWNLOAD_TYPES,
  FILE_FORMATS,
  PRODUCTS_LIMIT,
  PRODUCTS_VIEW,
  searchBarPlaceholderText,
  TOOLKIT_PAGE,
  wishlistAction,
} from '@/constants'
import store from '@/store'
import {
  DOWNLOAD_COLLECTION,
  FETCH_COLLECTION_PRODUCT_FILTERS,
} from '@/store/modules/collection.module'
import {
  SET_IS_CREATE_WISHLIST_BTN_DISABLED,
  SET_IS_ENABLE_REMOVE_WISHLIST_BUTTON,
} from '@/store/modules/wishlist.module'
import { FETCH_DIRECT_RETAILERS } from '@/store/modules/connections.module'
import {
  SET_REPLACE_CART_PRODUCT,
  UPDATE_SELECT_COUNT,
  UPDATE_SELECT_TYPE,
  MULTI_SELECT_PAGES,
  isEnabledHintPopup,
  UPDATE_SELECTED_DIRECT_RETAILER,
  FETCH_WISHLISTS,
  UPDATE_TOTAL_PRODUCTS_COUNT,
  UPDATE_IS_SELECTED_ALL_PRODUCTS,
  ADD_PRODUCT_TO_WISHLIST,
  UPDATE_CART_ITEMS_COUNT,
} from '@/store/modules/shop.module'
import ConnectionRequest from '@/views/apps/wallet/ConnectionRequest.vue'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import { apiToastSuccess, apiToastWarning } from '@core/utils/toast'
import {
  debounce,
  elementInViewport,
  formatObject,
  textTruncate,
} from '@core/utils/utils'
import { constants as c, utils } from '@kingpin-global/kingpin-utils-frontend'

import {
  computed,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from '@vue/composition-api'
import {
  BButton,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormInput,
  BImg,
  BInputGroup,
  BListGroup,
  BListGroupItem,
  BModal,
  BRow,
  BSpinner,
  VBModal,
  VBTooltip,
  BCardText,
  BTooltip,
} from 'bootstrap-vue'
import Vue from 'vue'
import Ripple from 'vue-ripple-directive'
import { mapState } from 'vuex'
import CurrencyDropdown from '@/views/components/currency-dropdown/CurrencyDropdown.vue'
import { SHOW_DOWNLOADS_NAV_INDICATOR, SHOW_WISHLIST_NAV_INDICATOR } from '@/store/modules/notification.module'
import SelectAllButton from '@/views/components/select-all-btn/SelectAllButton.vue'
import { useSelections } from '@/@core/comp-functions/selections/useSelection'
import { handleOptimisticUpdateForWishlist } from '@/@core/comp-functions/wishlistUtils'
import { useEcommerceUi } from '../useEcommerce'
import AddProductsSelectionHintModal from './AddProductsSelectionHintModal.vue'
import EmptyProductsMessage from './EmptyProductsMessage.vue'
import ShopFilter from './ShopFilter.vue'
import ShopProducts from './ShopProducts.vue'
import {
  useShopFiltersSortingAndPagination,
  useShopRemoteData,
  useShopUi,
} from './useECommerceShop'
import ShopMixin from './ShopMixin.vue'

const { formatCurrency } = utils

const { BRAND_ACCESS, ROLES } = c
const { CONNECTION_REQUEST_STATUS, DOWNLOAD_OPTIONS, TRACKS } = constants
const { MULTI_SELECT_PRODUCTS } = TRACKS.ACTIONS

export default {
  directives: {
    Ripple,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  components: {
    // BSV
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BButton,
    BSpinner,
    BFormCheckbox,
    BImg,
    ShopProducts,
    BModal,
    AddProductsSelectionHintModal,
    BCardText,
    CollectionDownloadPicker,
    BTooltip,
    // SFC
    ShopFilter,
    FeatherIcon,
    ConnectionRequest,
    BListGroup,
    BListGroupItem,
    LargeGridViewIcon,
    CompactGridViewIcon,
    EmptyProductsMessage,
    CurrencyDropdown,
    SelectAllButton,
  },
  mixins: [ShopMixin],
  props: {
    collectionId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      productList: [],
      retailerId: null,
      itemViewClass: PRODUCTS_VIEW.GRID_VIEW,
      TOOLKIT_PAGE,
      PRODUCTS_VIEW,
      filterIcon: require('@/assets/images/icons/filterIcon.svg'),
      searchText: '',
      textTruncate,
      searchBarPlaceholderText,
      showSearchBarToolTip: false,
      isFocusedSearchBar: false,
    }
  },
  computed: {
    isShowWsp() {
      return !(
        this.isWspHidden
        && this.connectionRequestStatus !== CONNECTION_REQUEST_STATUS.APPROVED
      )
    },
    shouldShowInfiniteLoader() {
      return this.wishlistItemsCount > 20 && this.continueLoading
    },
    shouldShowEmptyWishlistMsg() {
      return (
        this.selectedWishlist?._id
        && this.wishlistItemsCount <= 0
        && !this.isFetchingWishlists
        && !this.filters.search
      )
    },
    isGuest() {
      return store.getters.isGuest
    },
    ...mapState({
      profileData: state => state.auth.profileData,
      selectCount: state => state.shop.selectCount,
    }),
    wishlistBtnLabel() {
      if (!this.selectedWishlist) {
        return 'Select a wishlist'
      } else if (this.selectedWishlist?._id === '') {
        return `${this.selectedWishlist.name} (${this.totalProducts ?? 0})`
      } else {
        return `${textTruncate(this.selectedWishlist.name, true, 20, 15)} (${
          this.selectedWishlist.count || 0
        })`
      }
    },
    wishlistItemsCount() {
      if (this.selectedWishlist && this.selectedWishlist?._id !== '') {
        return this.selectedWishlist.count ?? 0
      } else return this.totalProducts
    },
  },
  created() {
    this.$root.$refs.shopItems = this
    store.commit(UPDATE_SELECT_TYPE, MULTI_SELECT_PAGES.SHOP)
    if (this.isRetailer) {
      this.retailerId = this.profileData?._id
      analytics.track(constants.TRACKS.PAGES.SHOP)
    }
    this.loadWishlists()
  },
  destroyed() {
    store.commit(UPDATE_SELECT_COUNT, 0)
    store.commit(UPDATE_IS_SELECTED_ALL_PRODUCTS, false)
    analytics.track(
      this.isBrand
        ? constants.TRACKS.ACTIONS.BRAND_END_VIEWING_COLLECTION
        : constants.TRACKS.ACTIONS.RETAILER_END_VIEWING_COLLECTION,
      this.collectionData,
    )
  },
  methods: {
    trackGridView(event) {
      analytics.track(
        event,
        formatObject({ noOfProductsInCollection: this.totalProducts }),
      )
    },
    onCompactToggleClick() {
      if (this.itemViewClass === PRODUCTS_VIEW.GRID_VIEW) {
        this.itemViewClass = PRODUCTS_VIEW.COMPACT_GRID_VIEW
        this.trackGridView(
          this.isBrand
            ? constants.TRACKS.ACTIONS.BRAND_SELECTS_COMPACT_VIEW
            : constants.TRACKS.ACTIONS.RETAILER_SELECTS_COMPACT_VIEW,
        )
      } else {
        this.itemViewClass = PRODUCTS_VIEW.GRID_VIEW
        this.trackGridView(
          this.isBrand
            ? constants.TRACKS.ACTIONS.BRAND_SELECTS_GENERAL_VIEW
            : constants.TRACKS.ACTIONS.RETAILER_SELECTS_GENERAL_VIEW,
        )
      }
    },

    closeModal() {
      this.$refs.connectionRequest.hide()
    },
    onClickGuestSignUp() {
      this.$root.$refs.guestSignup.openModal()
    },
  },

  setup(props, { root }) {
    const { sortBy, sortByOptions } = useShopFiltersSortingAndPagination()
    const {
      handleCartActionClick,
      toggleProductInWishlist,
      addMultipleItemsInCart,
      markItemsAsInCart,
      parseProductImage,
    } = useEcommerceUi()
    const collectionData = ref({})
    const selectedWishlistId = ref('')
    const selectedWishlist = ref(null)
    const wishlists = ref([])
    const isFetchingWishlists = ref(true)
    const isDisableCreateWishlist = computed({
      get: () => root.$store.state.wishlist.isCreateWishlistBtnDisabled,
      set: val => {
        root.$store.commit(SET_IS_CREATE_WISHLIST_BTN_DISABLED, val)
      },
    })
    const shouldChangeWishlist = ref(false)

    const isBrand = computed(
      () => root.$store.getters.entityType === ROLES.BRAND,
    )

    const deselectedProducts = ref([])
    const fetchQueryParams = ref({})
    const collectionBaseCurrency = ref('')

    const onClickSelectWishlist = () => {
      shouldChangeWishlist.value = true
      isDisableCreateWishlist.value = true
      root.$bvModal.show('wishlist-list')
    }

    const trackWishlistToggleAnalytics = product => {
      if (!isRetailer.value) return
      const event = product.isInWishlist
        ? constants.TRACKS.ACTIONS.RETAILER_ADDS_TO_WISHLIST
        : constants.TRACKS.ACTIONS.RETAILER_REMOVES_FROM_WISHLIST
      analytics.track(event, formatObject({
        collectionName: collectionData.value?.collectionName,
        createdBy: ROLES.RETAILER,
      }))
    }

    const applyWishlistToggleResult = (updatedProduct, index, groupIndex, product) => {
      if (Array.isArray(updatedProduct)) {
        updatedProduct.forEach((updatedProducts, ind) => {
          Vue.set(products.value, index[ind], updatedProducts)
        })
      } else {
        if (products.value[groupIndex]?.products.length) {
          Vue.set(products.value[groupIndex].products, index, updatedProduct)
        }
        trackWishlistToggleAnalytics(product)
      }
    }

    const buildToggleProductProps = p => {
      const props = {
        product: p.product,
        wishlistId: p.wishlistIdValue,
        action: p.action,
        wishlistName: p.wishlistName,
        wishlist: p.wishlist,
        collectionName: collectionData.value?.collectionName,
        fullIdsList: p.index,
      }
      const isRemoveAction = p.action === wishlistAction.REMOVE_FROM_WISHLIST
      const hasSelectedWishlist = selectedWishlist?.value?._id
      const isRemoveAll = isSelectAll.value && hasSelectedWishlist && isRemoveAction
      if (isRemoveAll) {
        props.wishlist = selectedWishlist.value
        props.action = wishlistAction.REMOVE_IN_WISHLIST
      }
      return { props, isRemoveAll }
    }

    const reactToggleProductInWishlistImpl = async opts => {
      const {
        product,
        index,
        groupIndex,
        action,
        wishlistId = null,
        wishlistName = '',
        wishlist = null,
        isCreateWishlist = false,
        optimistic = false,
      } = opts
      store.commit(UPDATE_SELECT_COUNT, 0)
      const wishlistIdValue = !isCreateWishlist ? wishlistId || selectedWishlistId.value : null

      if (optimistic) {
        handleOptimisticUpdateForWishlist({
          product,
          index,
          products: products.value[groupIndex].products,
          action,
          wishlistId: wishlistIdValue,
        })
      }

      const { props: toggleProductProps, isRemoveAll } = buildToggleProductProps({
        product,
        index,
        wishlistIdValue,
        action,
        wishlist,
        wishlistName,
      })
      const updatedProduct = await toggleProductInWishlist(toggleProductProps)
      if (isRemoveAll) {
        isSelectAll.value = false
        store.commit(UPDATE_SELECT_COUNT, 0)
      }
      applyWishlistToggleResult(updatedProduct, index, groupIndex, product)
      loadWishlists(isCreateWishlist)
    }

    const reactToggleProductInWishlist = (...args) => {
      const [product, index, groupIndex, action, wishlistId, wishlistName, wishlist, isCreateWishlist, optimistic] = args
      return reactToggleProductInWishlistImpl({
        product,
        index,
        groupIndex,
        action,
        wishlistId: wishlistId ?? null,
        wishlistName: wishlistName ?? '',
        wishlist: wishlist ?? null,
        isCreateWishlist: isCreateWishlist ?? false,
        optimistic: optimistic ?? false,
      })
    }

    const conflictedProductIndices = ref({})

    const updateProductAfterConflict = updatedProduct => {
      const { groupIndex, index } = conflictedProductIndices.value
      if (groupIndex !== undefined && index !== undefined) {
        updatedProduct.isInCart = true
        Vue.set(products.value[groupIndex].products, index, updatedProduct)
        handleReplaceCartProduct()
        analytics.track(
          constants.TRACKS.ACTIONS.ADD_TO_CART,
          formatObject(updatedProduct),
        )
        analytics.track(
          constants.TRACKS.ACTIONS.RETAILER_ADDS_TO_CART,
          formatObject({ collectionName: collectionData.value?.collectionName }),
        )
        conflictedProductIndices.value = {}
      }
    }

    const reactHandleCartActionClick = async (product, index, groupIndex) => {
      const updatedProduct = await handleCartActionClick({
        product,
        location: 'shopItems',
        conflictResolveCallback: 'updateProductAfterConflict',
      })
      if (updatedProduct) {
        Vue.set(products.value[groupIndex].products, index, updatedProduct)
        handleReplaceCartProduct()
        analytics.track(
          constants.TRACKS.ACTIONS.RETAILER_ADDS_TO_CART,
          formatObject({ collectionName: collectionData.value?.collectionName }),
        )
      } else {
        conflictedProductIndices.value = {
          groupIndex,
          index,
        }
      }
    }

    const selectedProductIdsCount = ref(0)

    const updateMultipleProductsAfterConflict = updatedProducts => {
      if (Array.isArray(updatedProducts)) {
        markItemsAsInCart(updatedProducts)
        store.commit(UPDATE_CART_ITEMS_COUNT, selectedProductIdsCount.value)
        analytics.track(
          constants.TRACKS.ACTIONS.RETAILER_ADDS_SELECTED_ITEMS_TO_CART,
          formatObject({
            collectionName: collectionData.value?.collectionName,
            noOfProductsSelected: updatedProducts?.length,
          }),
        )
      }
    }

    const addMultipleItemsCartActionClick = async ({
      selectedProductsIds,
      product,
    }) => {
      selectedProductIdsCount.value = selectedProductsIds?.length
      const updatedProduct = await addMultipleItemsInCart({
        selectedProductsIds,
        product,
        location: 'shopItems',
        conflictResolveCallback: 'updateMultipleProductsAfterConflict',
        skipUpdateCartCount: true,
      })
      isSelectAll.value = false
      store.commit(UPDATE_SELECT_COUNT, 0)
      if (Array.isArray(updatedProduct)) {
        analytics.track(
          constants.TRACKS.ACTIONS.RETAILER_ADDS_SELECTED_ITEMS_TO_CART,
          formatObject({
            collectionName: collectionData.value?.collectionName,
            noOfProductsSelected: updatedProduct?.length,
          }),
        )
      }
      handleReplaceCartProduct()
    }

    const handleReplaceCartProduct = async () => {
      const replacingProduct = await root.$store.getters.getReplaceCarProduct
      // Redirect to cart page if the replacing product present
      if (replacingProduct) {
        root.$router.push({ name: 'checkout' })
      }
    }

    const {
      itemView,
      itemViewOptions,
      totalProducts,
      isWspHidden,
      isBrandNotAccessible,
      connectionRequestStatus,
      brandId,
      filterByAvailabilityDates,
    } = useShopUi()

    const { products, fetchProducts } = useShopRemoteData()

    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()

    // filtering
    const filters = ref({
      search: '',
      page: 0,
      limit: PRODUCTS_LIMIT,
    })
    const filterOptions = ref({})
    const filterSetup = ref(false)
    const selcetedAvailabiltyDateIndex = ref([])
    const selectedAvailabilityDate = ref([])
    const selectedDeliveryDate = []
    const showDateFilter = ref(false)
    const showFilterDateOptions = ref(false)
    let initialWholesalePriceMax
    let initialWholesalePriceMin
    let initialRetailPriceMax
    let initialRetailPriceMin
    let productsCount = 0

    const inactiveCollection = ref(false)
    const groups = ref({})
    const defaultGroup = ref('None')
    const selectedGroup = ref(defaultGroup.value)

    const isFilterApplied = ref(false)
    const directRetailerId = ref(null)

    const isRetailer = computed(() => root.$store.getters.isRetailer)
    const isGuest = computed(() => root.$store.getters.isGuest)
    const profile = computed(() => root.$store.getters.profile)
    const hasDirectRetailers = ref(false)
    const downloading = ref(false)
    const shopProductsRef = ref(null)

    const groupProducts = group => {
      selectedGroup.value = group
      isFilterApplied.value = true
      filters.value.page = 0
      fetchShopProducts()
      if (isRetailer.value) {
        analytics.track(
          constants.TRACKS.ACTIONS.RETAILER_GROUPS_PRODUCTS,
          formatObject({ selectedGroup: group }),
        )
      }
    }

    const copyFiltersIntoParams = fetchParam => {
      for (const key in filters.value) {
        if (Object.prototype.hasOwnProperty.call(filters.value, key)) {
          const val = filters.value[key]
          fetchParam[key] = Array.isArray(val) && val.length ? val.join(',') : val
        }
      }
    }

    const resetAvailabilityDateFilters = () => {
      selcetedAvailabiltyDateIndex.value = []
      selectedAvailabilityDate.value = []
      showDateFilter.value = false
      showFilterDateOptions.value = false
    }

    const addOptionalFetchParams = (fetchParam, shipWishlist) => {
      if (profile.value?.isDemo) fetchParam.isDemo = true
      if (selectedWishlistId.value && !shipWishlist) fetchParam.wishlistId = selectedWishlistId.value
      if (directRetailerId.value) fetchParam.retailerId = directRetailerId.value
    }

    const getFetchParams = (resetFilters = false, shipWishlist) => {
      const fetchParam = { sortBy: sortBy.value.value, page: filters.value.page }
      addOptionalFetchParams(fetchParam, shipWishlist)
      copyFiltersIntoParams(fetchParam)
      if (resetFilters) resetAvailabilityDateFilters()
      const dateIndexes = selcetedAvailabiltyDateIndex.value
      if (dateIndexes.length) {
        fetchParam.availabilityDates = dateIndexes.map(date => filterByAvailabilityDates.value[date]).join(',')
      }
      fetchParam.groupBy = selectedGroup.value || defaultGroup.value
      if (props.collectionId) fetchParam.collectionId = props.collectionId
      return fetchParam
    }
    const toggleRemoveAllBtn = val => {
      root.$store.commit(SET_IS_ENABLE_REMOVE_WISHLIST_BUTTON, val)
    }
    const indexes = ref([])
    const shipWishlist = false
    const isSelectAll = ref(false)

    const { onToggleSelectAll, isSelectedAllOnScreen } = useSelections(
      products,
      getFetchParams,
      indexes,
      shipWishlist,
      toggleRemoveAllBtn,
    )

    const forceToggleSelect = forceSelect => {
      onToggleSelectAll({
        forceSelect,
        selectedWishlistId: selectedWishlistId.value,
      })
    }

    const toggleSelectAllHandler = () => {
      isSelectAll.value = true
      onToggleSelectAll({
        selectEventTrack: () => analytics.track(
            MULTI_SELECT_PRODUCTS.USER_CLICKS_SELECT_ALL_PRODUCTS_IN_COLLECTION_PRODUCTS_PAGE,
            { collectionDetails: collectionData.value },
          ),
        unselectEvent: () => analytics.track(
            MULTI_SELECT_PRODUCTS.USER_CLICKS_DESELECT_ALL_PRODUCTS_IN_COLLECTION_PRODUCTS_PAGE,
            { collectionDetails: collectionData.value },
          ),
        selectedWishlistId: selectedWishlistId.value,
      })
    }

    // KP-3919: shared picker chooses the deliverable; the shop payload
    // carries file names only — the files themselves are attached
    // server-side.
    const downloadCollection = choice => {
      // With the flag off this is the old plain button, which passes no
      // choice (and would otherwise pass a MouseEvent) — so the payload stays
      // exactly what it was, and the modal always closes on success.
      const withPicker = brandCatalogueFlagOn()
      const payload = {
        retailerId: directRetailerId.value,
        respectiveId: props.collectionId,
        fileType: FILE_FORMATS.XLSX,
        downloadType: DOWNLOAD_TYPES.COLLECTION_EXPORT.VALUE,
        ...(withPicker ? choice : {}),
      }
      downloading.value = true
      root.$store
        .dispatch(DOWNLOAD_COLLECTION, { payload })
        .then(res => {
          apiToastSuccess(res.data.message)
          if (!withPicker || choice?.deliverable === DOWNLOAD_DELIVERABLE.ALL) {
            root.$bvModal.hide('download_catalog')
          }
          root.$store.commit(SHOW_DOWNLOADS_NAV_INDICATOR)
        })
        .catch(() => {})
        .finally(() => {
          downloading.value = false
        })
    }

    const openDownloadCollection = () => {
      downloading.value = false
      root.$bvModal.show('download_catalog')
    }

    const handleNewFilter = newFilter => {
      if (newFilter && typeof newFilter === 'object') {
        isFilterApplied.value = true
        filters.value = newFilter
        filters.value.page = 0
        if (initialWholesalePriceMax === filters.value.wholesalePriceMax) delete filters.value.wholesalePriceMax
        if (initialWholesalePriceMin === filters.value.wholesalePriceMin) delete filters.value.wholesalePriceMin
        if (initialRetailPriceMax === filters.value.retailPriceMax) delete filters.value.retailPriceMax
        if (initialRetailPriceMin === filters.value.retailPriceMin) delete filters.value.retailPriceMin
      }
    }

    const getConnectionStatus = result => (Object.prototype.hasOwnProperty.call(result, 'connectionRequestStatus') && result.connectionRequestStatus) || null

    const applyCollectionResultState = (result, fetchParam) => {
      root.$store.commit(UPDATE_TOTAL_PRODUCTS_COUNT, result.count)
      collectionData.value = result
      if (!fetchParam.currency) {
        collectionBaseCurrency.value = result.products[0]?.products[0]?.currency
      }
      if (Object.prototype.hasOwnProperty.call(result, 'isCollectionExpired')) {
        inactiveCollection.value = result.isCollectionExpired
      }
      connectionRequestStatus.value = getConnectionStatus(result)
      isWspHidden.value = Object.prototype.hasOwnProperty.call(result, 'isWspHidden') && result.isWspHidden
      isBrandNotAccessible.value = Object.prototype.hasOwnProperty.call(result, 'isBrandNotAccessible') && result.isBrandNotAccessible
    }

    const buildProductColorsFromItems = items => {
      const productColors = []
      const colorKeys = []
      items.forEach(item => {
        const key = `${item.colorFamily || ''}_${item.hexCode || ''}`
        const existingIndex = colorKeys.indexOf(key)
        if (existingIndex < 0) {
          colorKeys.push(key)
          productColors.push({ colorNames: [item.color], colorFamily: item.colorFamily, hexCode: item.hexCode })
        } else {
          const existingColors = productColors[existingIndex].colorNames
          const colorNotInList = item.color && !existingColors.includes(item.color)
          if (colorNotInList) existingColors.push(item.color)
        }
      })
      return productColors
    }

    const processOneProductForColorSwatches = product => {
      productsCount++
      product.quantity = product.quantity || 1
      product.colors = buildProductColorsFromItems(product.items || [])
    }

    const processProductGroupForColorSwatches = groupedProduct => {
      groupedProduct.products.forEach(processOneProductForColorSwatches)
    }

    const resetProductsCountIfFirstPage = page => {
      if (page === 0) productsCount = 0
    }

    const processAllGroupsForColorSwatches = (productGroups, page) => {
      resetProductsCountIfFirstPage(page)
      for (let i = 0; i < productGroups.length; i++) {
        processProductGroupForColorSwatches(productGroups[i])
      }
    }

    const processProductColorSwatches = result => {
      processAllGroupsForColorSwatches(result.products, result.page)
    }

    const mergeFirstResultGroupIntoLastIfSame = result => {
      const hasResultProducts = result.products.length > 0
      const hasCurrentProducts = products.value.length > 0
      if (!hasResultProducts || !hasCurrentProducts) return
      const lastGroup = products.value[products.value.length - 1]
      const firstResult = result.products[0]
      if (lastGroup._id !== firstResult._id) return
      lastGroup.products = lastGroup.products.concat(firstResult.products)
      result.products.splice(0, 1)
    }

    const applyProductsFromResult = result => {
      if (result.page >= 1) {
        mergeFirstResultGroupIntoLastIfSame(result)
        products.value = [...products.value, ...result.products]
      } else {
        products.value = result.products
      }
    }

    const mergeOrSetProducts = result => {
      continueLoading.value = result.count > productsCount
      applyProductsFromResult(result)
      totalProducts.value = result.count
      brandId.value = result.brandId
    }

    const trackCollectionViewIfInitial = result => {
      if (isFilterApplied.value) return
      const pageEvent = isBrand.value ? constants.TRACKS.PAGES.BRAND_OPENS_COLLECTION : constants.TRACKS.PAGES.RETAILER_OPENS_COLLECTION
      const actionEvent = isBrand.value ? constants.TRACKS.ACTIONS.BRAND_START_VIEWING_COLLECTION : constants.TRACKS.ACTIONS.RETAILER_START_VIEWING_COLLECTION
      analytics.track(pageEvent, formatObject(getCollectionMixpanelObj(result)))
      analytics.track(actionEvent, formatObject(collectionData.value))
    }

    const showHintModalIfEnabled = () => {
      if (isBrand.value && localStorage.getItem(isEnabledHintPopup) === 'true') {
        localStorage.setItem(isEnabledHintPopup, false)
        root.$bvModal.show('hint_selection_modal')
      }
    }

    const fetchShopProducts = (newFilter, resetFilters = false) => new Promise(resolve => {
      isFetchingWishlists.value = true
      handleNewFilter(newFilter)
      const fetchParam = getFetchParams(resetFilters)
      if (filterSetup.value) updateFilter(fetchParam)

      fetchProducts(fetchParam)
        .then(response => {
          const result = response.data.data
          applyCollectionResultState(result, fetchParam)
          processProductColorSwatches(result)
          mergeOrSetProducts(result)
          trackCollectionViewIfInitial(result)
          resolve(response)
          showHintModalIfEnabled()
          fetchQueryParams.value = fetchParam
        })
        .catch(err => {
          if (err.response?.status === 404) {
            products.value = []
            totalProducts.value = 0
            isLoading.value = false
          } else {
            apiToastWarning(err)
          }
        })
        .finally(() => {
          isFetchingWishlists.value = false
        })
      if (isFilterApplied.value) {
        const filterEvent = isBrand.value ? constants.TRACKS.ACTIONS.BRAND_APPLIES_FILTER_CLN : constants.TRACKS.ACTIONS.RETAILER_APPLIES_FILTER_CLN
        analytics.track(filterEvent, formatObject(fetchParam))
      }
    })

    const filterByCurrency = (currency = '') => {
      if (!currency) {
        delete filters.value?.currency
      } else {
        filters.value.currency = currency
        filters.value.page = 0
      }
      fetchShopProducts()
    }

    const setWishlist = (wishlistId = '', isCreateWishlist = false) => {
      if (!wishlistId) {
        selectedWishlistId.value = ''
        if (wishlists.value?.length) {
          selectedWishlist.value = {
            name: 'None',
            _id: '',
            count: totalProducts,
          }
          selectedWishlistId.value = selectedWishlist.value._id
          if (isCreateWishlist) {
            fetchShopProducts()
          }
        }
        return
      }
      selectedWishlistId.value = !isBrand.value && wishlistId

      selectedWishlist.value = wishlists.value.find(
        wishlist => wishlist?._id === selectedWishlistId.value,
      )
    }

    const updateProductsByWishlistId = data => {
      if (shouldChangeWishlist.value && !isBrand.value) {
        setWishlist(data.wishlistId)
      }
      shouldChangeWishlist.value = false
      isDisableCreateWishlist.value = false
      isSelectAll.value = false
      filters.value.page = 0
      fetchShopProducts()
    }

    watch(
      [sortBy],
      () => {
        if (filterSetup.value) {
          filters.value.page = 0
          fetchShopProducts()
        }
      },
      {
        deep: true,
      },
    )

    // update filter options when select a menu
    const updateFilter = async fetchParam => {
      if (directRetailerId.value) {
        fetchParam.retailerId = directRetailerId.value
      }
      await root.$store
        .dispatch(FETCH_COLLECTION_PRODUCT_FILTERS, fetchParam)
        .then(res => {
          const filterMenus = res.data.data[0]
          if (filterMenus !== undefined) {
            const filerMenuFields = [
              'lines',
              'departments',
              'categories',
              'subCategories',
              'gender',
              'colors',
              'sizes',
              'subLines',
              'groups',
              'subGroups',
              'keyStyles',
              'segmentTags',
            ]
            filerMenuFields.forEach(field => {
              filterOptions.value[field] = setFilter(
                filterOptions.value[field],
                fetchParam[field],
                filterMenus[field],
              )
            })
            filterByAvailabilityDates.value = setFilter(
              filterByAvailabilityDates.value,
              fetchParam.availabilityDates,
              filterMenus.availabilityDates,
            )
            groups.value = filterMenus.groupBy
          }
        })
    }

    const applyPriceRangesAndFilterDefaults = opts => {
      for (const key in opts) {
        if (Object.prototype.hasOwnProperty.call(opts, key)) {
          filters.value[key] = []
          const isPriceMax = key.indexOf('PriceMax') > -1
          const isPriceMin = key.indexOf('PriceMin') > -1
          if (isPriceMax) opts[key] = Math.round(opts[key]) + 1
          if (isPriceMin) opts[key] = Math.round(opts[key]) - 1
        }
      }
    }

    const hasValidAvailabilityDates = opts => {
      const dates = opts?.availabilityDates
      return Array.isArray(dates) && dates.length > 0
    }

    const applyFilterSetupFromOptions = opts => {
      if (hasValidAvailabilityDates(opts)) {
        filterByAvailabilityDates.value = opts.availabilityDates.filter(Boolean)
      }
      opts.retailPrice = [opts.retailPriceMin, opts.retailPriceMax]
      opts.wholesalePrice = [opts.wholesalePriceMin, opts.wholesalePriceMax]
      groups.value = opts.groupBy
      initialWholesalePriceMax = opts.wholesalePriceMax
      initialWholesalePriceMin = opts.wholesalePriceMin
      initialRetailPriceMax = opts.retailPriceMax
      initialRetailPriceMin = opts.retailPriceMin
      filterSetup.value = true
    }

    const applyFilterOptionsResponse = res => {
      const opts = res?.data?.data?.[0]
      filterOptions.value = opts
      filterOptions.value.colorEntries = buildColorEntries(opts)
      const hasValidOpts = opts != null
      if (hasValidOpts) {
        applyPriceRangesAndFilterDefaults(opts)
        applyFilterSetupFromOptions(opts)
      }
      getDirectRetailers()
    }

    const fetchShopFilters = async () => {
      const payload = {
        collectionId: props.collectionId,
        isDemo: !!profile.value?.isDemo,
        retailerId: directRetailerId.value ?? null,
      }
      const res = await root.$store.dispatch(FETCH_COLLECTION_PRODUCT_FILTERS, payload)
      applyFilterOptionsResponse(res)
    }

    if (!filterSetup.value) fetchShopFilters()
    const loadWishlists = async (isCreateWishlist = false) => {
      await store
        .dispatch(FETCH_WISHLISTS, {
          force: true,
          collectionId: props.collectionId,
        })
        .then(resWishlists => {
          wishlists.value = resWishlists.filter(
            wishlist => !wishlist.isReadOnly,
          )
        })
      setWishlist(selectedWishlistId.value || '', isCreateWishlist)
      // fetch products
      fetchShopProducts().then(response => {
        // update breadcrumb
        root.$route.meta.breadcrumb = root.$route.meta.breadcrumb.map(
          item => {
            if (item.dynamic === true) {
              if (item.hasOwnProperty('routeName')) {
                // display brand name instead for retailer view
                if (isRetailer.value || isGuest.value) {
                  item.routeName = response.data.data.brandName
                  item.to = {
                    name: 'brand/detail',
                    params: { brandId: response.data.data.brandId },
                  }
                }
                // display collection list
                else {
                  item.routeName = 'Collections'
                  item.to = { name: 'collections' }
                }
              } else if (item.hasOwnProperty('collectionName')) {
                item.collectionName = response.data.data.collectionName
              }
            }
            return item
          },
        )
      })
    }

    // Load wishlists
    loadWishlists()

    const getDirectRetailers = async () => {
      const access = profile.value?.access || []
      if (isBrand && access.includes(BRAND_ACCESS.DIRECT)) {
        const directRetailers = await root.$store.dispatch(
          FETCH_DIRECT_RETAILERS,
        )
        if (directRetailers?.length) {
          hasDirectRetailers.value = true
        }
      }
    }

    const setDirectRetailerInfo = (id = null) => {
      directRetailerId.value = id
      products.value = []
      isLoading.value = true
      filters.value.currency = ''
      filters.value.page = 0
      root.$store.commit(UPDATE_SELECT_COUNT, 0)
      root.$store.commit(UPDATE_IS_SELECTED_ALL_PRODUCTS, false)
      root.$refs.shop.forceToggleSelect(false)
      fetchShopProducts().then(() => {
        isLoading.value = false
      })
    }

    // loading on scroll
    const isLoading = ref(false)
    const loadingIcon = ref(null)
    const continueLoading = ref(false)

    const onScrollLoader = () => {
      if (!isLoading.value && elementInViewport(loadingIcon.value)) {
        isLoading.value = true
        filters.value.page++
        fetchShopProducts().then(() => {
          isLoading.value = false
        })
      }
    }

    const requestForConnection = () => {
      connectionRequestStatus.value = CONNECTION_REQUEST_STATUS.PENDING
    }

    const filterByDate = () => {
      isFilterApplied.value = true
      // track obj for mixpanel
      const trackObj = {
        'Selected Delivery Dates': selectedDeliveryDate.length
          ? selectedDeliveryDate
          : [],
      }
      analytics.track(
        isBrand.value
          ? constants.TRACKS.ACTIONS.BRAND_APPLIES_DELIVERY_DATES_FILTER
          : constants.TRACKS.ACTIONS.RETAILER_APPLIES_DELIVERY_DATES_FILTER,
        trackObj,
      )
      selcetedAvailabiltyDateIndex.value = selectedAvailabilityDate.value.slice()
      showDateFilter.value = false
      showFilterDateOptions.value = false
      filters.value.page = 0
      fetchShopProducts()
    }
    const setDateFiler = dateIndex => {
      const index = selectedAvailabilityDate.value.indexOf(dateIndex)
      if (index !== -1) {
        selectedAvailabilityDate.value.splice(index, 1)
        selectedDeliveryDate.splice(index, 1)
      } else {
        selectedAvailabilityDate.value.push(dateIndex)
        selectedDeliveryDate.push(filterByAvailabilityDates.value[dateIndex])
      }
    }
    const removeDateFilter = dateIndex => {
      const index = selectedAvailabilityDate.value.indexOf(dateIndex)
      if (index !== -1) {
        selectedAvailabilityDate.value.splice(index, 1)
      }
      const filterIndex = selcetedAvailabiltyDateIndex.value.indexOf(dateIndex)
      if (filterIndex !== -1) {
        selcetedAvailabiltyDateIndex.value.splice(index, 1)
        fetchShopProducts()
      }
    }
    const searchProducts = debounce(() => {
      isFilterApplied.value = true
      filters.value.page = 0
      fetchShopProducts()
    }, 1000)

    const closeSideBar = () => {
      mqShallShowLeftSidebar.value = false
    }

    const onSelectAllMoveToWishlist = ({
      wishlistId,
      wishlistName,
      isCreateWishlist,
      fullIdsList,
    }) => {
      const payload = {
        deselectedProducts: deselectedProducts.value?.map(p => p._id),
      }
      if (fullIdsList) {
        payload.products = fullIdsList.map(productId => ({ productId }))
      } else {
        fetchQueryParams.value.isSelectedAllProducts = true
      }
      let filterQueries = {}
      fetchQueryParams.value.collectionId = props.collectionId
      if (selectedWishlist.value?._id) {
        fetchQueryParams.value.wishlistId = selectedWishlist.value._id
      }
      filterQueries = fetchQueryParams.value
      delete filterQueries.page
      delete filterQueries.limit
      if (isCreateWishlist) {
        payload.name = wishlistName
      } else {
        payload.wishlistId = wishlistId
      }
      store
        .dispatch(ADD_PRODUCT_TO_WISHLIST, {
          payload,
          queryParams: filterQueries,
        })
        .then(res => {
          apiToastSuccess(res.data.message)
          store.commit(UPDATE_SELECT_COUNT, 0)
          store.commit(UPDATE_IS_SELECTED_ALL_PRODUCTS, false)
          deselectedProducts.value = []
          loadWishlists(isCreateWishlist)
          store.commit(SHOW_WISHLIST_NAV_INDICATOR)
        })
        .catch(() => {})
        .finally(() => {
          isSelectAll.value = false
        })
    }

    onMounted(() => {
      window.addEventListener('scroll', onScrollLoader)
      window.addEventListener('popstate', () => {
        root.$store.commit(SET_REPLACE_CART_PRODUCT, null)
      })
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', onScrollLoader)
      window.removeEventListener('popstate', () => {
        root.$store.commit(SET_REPLACE_CART_PRODUCT, null)
      })
      root.$store.commit(UPDATE_SELECTED_DIRECT_RETAILER, null)
    })

    return {
      isLoading,
      // useShopFiltersSortingAndPagination
      filters,
      filterOptions,
      filterSetup,
      sortBy,
      sortByOptions,
      loadingIcon,
      continueLoading,
      deselectedProducts,
      collectionBaseCurrency,
      isDisableCreateWishlist,

      // useShopUi
      itemView,
      itemViewOptions,
      totalProducts,
      fetchShopProducts,
      reactToggleProductInWishlist,
      reactHandleCartActionClick,
      addMultipleItemsCartActionClick,
      isWspHidden,
      isBrandNotAccessible,
      connectionRequestStatus,
      brandId,
      // Filter By Date variables
      filterByAvailabilityDates,
      selcetedAvailabiltyDateIndex,
      selectedAvailabilityDate,
      showDateFilter,
      showFilterDateOptions,
      groups,
      selectedGroup,
      // Filter By Date functions
      filterByDate,
      setDateFiler,
      removeDateFilter,
      onClickSelectWishlist,
      // Group products
      defaultGroup,
      groupProducts,
      // Filter By Search products
      searchProducts,
      // showelements,
      // useShopRemoteData
      products,
      inactiveCollection,
      // mqShallShowLeftSidebar
      mqShallShowLeftSidebar,
      closeSideBar,
      // extra
      parseProductImage,
      formatCurrency,
      requestForConnection,
      CONNECTION_REQUEST_STATUS,
      hasDirectRetailers,
      isRetailer: computed(
        () => root.$store.getters.entityType === ROLES.RETAILER,
      ),
      isBrand,
      setDirectRetailerInfo,
      directRetailerId,
      DOWNLOAD_OPTIONS,
      downloadCollection,
      ...useBrandCatalogueFlag(),
      downloading,
      openDownloadCollection,
      updateProductsByWishlistId,
      loadWishlists,
      setWishlist,
      selectedWishlistId,
      selectedWishlist,
      wishlists,
      onSelectAllMoveToWishlist,
      collectionData,
      filterByCurrency,
      isSelectedAllOnScreen,
      onToggleSelectAll: toggleSelectAllHandler,
      shopProductsRef,
      indexes,
      forceToggleSelect,
      updateProductAfterConflict,
      updateMultipleProductsAfterConflict,
      isFetchingWishlists,
      shouldChangeWishlist,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~@core/scss/base/pages/app-shop.scss';
@import '~@core/scss/vue/libs/vue-slider.scss';

.empty-wishlist-msg {
  display: flex;
  height: inherit;
  min-height: 400px;
  justify-content: center;
  align-items: center;
}
</style>
